(function () {
  if (window.__pdpProgressiveMediaReady) return;
  window.__pdpProgressiveMediaReady = true;

  var selector = '[data-pdp-deferred-media]';
  var observer = null;
  var tabsObserver = null;

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 991px)').matches;
  }

  function ensureScheduler() {
    if (window.__scheduleDeferredSectionHydration) {
      return window.__scheduleDeferredSectionHydration;
    }

    var queue = [];
    var running = false;

    window.__scheduleDeferredSectionHydration = function (callback) {
      queue.push(callback);
      if (running) return;
      running = true;

      function runNext() {
        var next = queue.shift();
        if (!next) {
          running = false;
          return;
        }

        next();
        if (queue.length) {
          window.setTimeout(runNext, 120);
        } else {
          running = false;
        }
      }

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(runNext, { timeout: 700 });
      } else {
        window.setTimeout(runNext, 90);
      }
    };

    return window.__scheduleDeferredSectionHydration;
  }

  function matchesViewport(target) {
    var viewport = target.dataset.pdpMediaViewport || 'all';
    if (viewport === 'mobile') return isMobile();
    if (viewport === 'desktop') return !isMobile();
    return true;
  }

  function isActivePane(target) {
    var pane = target.closest('xo-tabs-pane');
    if (!pane) return true;
    return pane.hasAttribute('xo-active') && pane.getAttribute('xo-active') !== 'false';
  }

  function isRenderable(target) {
    if (!matchesViewport(target)) return false;
    if (target.dataset.pdpMediaActivation === 'active-pane' && !isActivePane(target)) return false;
    return target.getClientRects().length > 0;
  }

  function settlePlaceholder(target, failed) {
    if (!target || target.dataset.pdpMediaReady === 'true') return;

    target.dataset.pdpMediaReady = 'true';
    target.setAttribute('aria-busy', 'false');
    if (failed) target.dataset.pdpMediaError = 'true';

    var placeholder = target.querySelector(':scope > .pdp-deferred-media__placeholder');
    if (!placeholder || failed) return;

    placeholder.classList.add('is-media-ready');
    window.setTimeout(function () {
      placeholder.remove();
    }, 240);
  }

  function watchMediaReady(target) {
    var observer = null;
    var timeout = null;

    function cleanup() {
      if (observer) observer.disconnect();
      if (timeout) window.clearTimeout(timeout);
    }

    function bindMedia() {
      var media = target.querySelector('img, video, iframe');
      if (!media) return false;

      function ready() {
        cleanup();
        settlePlaceholder(target, false);
      }

      function failed() {
        cleanup();
        settlePlaceholder(target, true);
      }

      if (media.matches('img')) {
        if (media.complete) {
          media.naturalWidth > 0 ? ready() : failed();
        } else {
          media.addEventListener('load', ready, { once: true });
          media.addEventListener('error', failed, { once: true });
        }
      } else if (media.matches('video')) {
        if (media.readyState >= 2) ready();
        else {
          media.addEventListener('loadeddata', ready, { once: true });
          media.addEventListener('error', failed, { once: true });
        }
      } else {
        media.addEventListener('load', ready, { once: true });
        media.addEventListener('error', failed, { once: true });
      }
      return true;
    }

    if (!bindMedia()) {
      observer = new MutationObserver(function () {
        if (bindMedia()) observer.disconnect();
      });
      observer.observe(target, { childList: true, subtree: true });
    }

    timeout = window.setTimeout(function () {
      cleanup();
      settlePlaceholder(target, true);
    }, 15000);
  }

  function mount(target) {
    if (!target || target.dataset.pdpMediaLoaded === 'true' || !isRenderable(target)) return;

    var template = target.querySelector(':scope > template[data-pdp-deferred-media-template]');
    if (!template) return;

    target.appendChild(template.content.cloneNode(true));
    template.remove();

    target.dataset.pdpMediaLoaded = 'true';
    target.dataset.pdpMediaQueued = '';
    watchMediaReady(target);
    target.dispatchEvent(new CustomEvent('pdp:media:mounted', { bubbles: true }));
  }

  function requestMount(target, immediate) {
    if (!target || target.dataset.pdpMediaLoaded === 'true') return;
    if (!isRenderable(target)) return;

    if (immediate) {
      mount(target);
      return;
    }

    if (target.dataset.pdpMediaQueued === 'true') return;
    target.dataset.pdpMediaQueued = 'true';

    ensureScheduler()(function () {
      target.dataset.pdpMediaQueued = '';
      mount(target);
    });
  }

  function requestActivePaneMedia(scope) {
    (scope || document).querySelectorAll(selector + '[data-pdp-media-near="true"]').forEach(function (target) {
      if (target.dataset.pdpMediaActivation === 'active-pane') requestMount(target, true);
    });
  }

  function pauseInactivePaneMedia(scope) {
    (scope || document).querySelectorAll('xo-tabs-pane').forEach(function (pane) {
      if (pane.hasAttribute('xo-active') && pane.getAttribute('xo-active') !== 'false') return;
      pane.querySelectorAll('video').forEach(function (video) {
        if (!video.paused) video.pause();
      });
    });
  }

  function mountImmediatelyNeeded(scope) {
    (scope || document).querySelectorAll(selector).forEach(function (target) {
      if (target.dataset.pdpMediaActivation === 'interaction') return;
      if (target.getBoundingClientRect().top > window.innerHeight * 1.1) return;
      requestMount(target, true);
    });
  }

  function bindInteractionTarget(target) {
    if (target.dataset.pdpMediaInteractionBound === 'true') return;
    target.dataset.pdpMediaInteractionBound = 'true';

    var host = target.closest('.multi-column-1__item') || target.parentElement;
    if (!host) return;

    ['pointerenter', 'pointerdown', 'focusin', 'touchstart'].forEach(function (eventName) {
      host.addEventListener(eventName, function () {
        requestMount(target, true);
      }, { once: true, passive: true });
    });
  }

  function observeTarget(target) {
    if (target.dataset.pdpMediaLoaded === 'true') return;
    if (target.dataset.pdpMediaObserved === 'true') return;
    target.dataset.pdpMediaObserved = 'true';

    if (target.dataset.pdpMediaActivation === 'interaction') {
      bindInteractionTarget(target);
      return;
    }

    observer.observe(target);
  }

  function scan(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(selector).forEach(observeTarget);
  }

  function createObserver() {
    if (observer) observer.disconnect();

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.dataset.pdpMediaNear = 'true';
        requestMount(entry.target, false);
      });
    }, {
      rootMargin: isMobile() ? '75% 0px' : '150% 0px',
      threshold: 0.01
    });
  }

  function init() {
    createObserver();
    scan(document);

    tabsObserver = new MutationObserver(function (mutations) {
      var changed = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'xo-active';
      });
      if (!changed) return;
      requestActivePaneMedia(document);
      pauseInactivePaneMedia(document);
    });
    tabsObserver.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['xo-active']
    });
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(selector).forEach(function (target) {
      requestMount(target, true);
    });
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('deferred-section:hydrate', function (event) {
    var scope = event.detail && event.detail.section ? event.detail.section : document;
    scan(scope);
    mountImmediatelyNeeded(scope);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  window.addEventListener('resize', function () {
    createObserver();
    document.querySelectorAll(selector).forEach(function (target) {
      target.dataset.pdpMediaObserved = '';
    });
    scan(document);
    requestActivePaneMedia(document);
  }, { passive: true });
})();
